import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";
import { sendEvent, useWindowSize } from "../../../../../Helpers";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import WrongAnswerPopup, {
  wrongAnswerPopupSpringSettings,
} from "@components/WrongAnswerPopup";
import DOMPurify from "dompurify";
import { a, useTransition } from "@react-spring/web";
import NiceModal from "@ebay/nice-modal-react";

export default function QuizInfo({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
  setUserPayload
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const queryClient = useQueryClient();
  const gameQuestionsQuery = queryClient.getQueryData([
    "game-questions",
    ident,
  ]);
  const XGA = width >= 1020;

  const handleNextButtonClick = (answerIdent = null) => {
    const currentQuestionIdent =
      gameQuestionsQuery.content[currentQuestion].ident;

    if (ident === "memory_5" && gameQuestionsQuery.content[currentQuestion]?.includeInAnswers) {
      let newAnswers = [...answers]
      newAnswers.push(
        {
          question_ident: currentQuestionIdent,
          answer_ident: answerIdent ?? gameQuestionsQuery.content[currentQuestion]?.customValue ?? "true",
        }
      )

      sendAnswers(
        () => { },
        newAnswers
      )

      setCurrentQuestion(prev => prev + 1)
      return
    }

    if (gameQuestionsQuery.content[currentQuestion]?.includeInAnswers) {
      setAnswers((prevAnswers) => {
        console.log(
          [
            ...prevAnswers,
            {
              question_ident: currentQuestionIdent,
              answer_ident: answerIdent ?? gameQuestionsQuery.content[currentQuestion]?.customValue ?? "true",
            },
          ]
        )

        return [
          ...prevAnswers,
          {
            question_ident: currentQuestionIdent,
            answer_ident: answerIdent ?? gameQuestionsQuery.content[currentQuestion]?.customValue ?? "true",
          },
        ];
      });
    }

    if (gameQuestionsQuery.answersNumber === answers.length) {
      console.log("Sending answers auto quiz");
      sendAnswers();
    }

    setCurrentQuestion(currentQuestion + 1);
  };

  console.log(answers);

  return (
    <section className={`game-page quiz-mechanics ${ident}`}>
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
              {gameQuestionsQuery.content[currentQuestion].questionDis && <p
                className="disclaimer"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].questionDis),
                }}
              />}
              {gameQuestionsQuery.content[currentQuestion].icons && (
                <div className="icons-wrapper">
                  {gameQuestionsQuery.content[currentQuestion].icons?.map(
                    (item, index) => (
                      <img className="icon" src={item} alt="" key={index} />
                    )
                  )}
                </div>
              )}
              {gameQuestionsQuery.content[currentQuestion].download && (
                <div className="download-wrapper">
                  <p>JETZT DOWNLOADEN</p>
                  {gameQuestionsQuery.content[currentQuestion].download?.map(
                    (item, index) => {
                      const isAndroid = index === 0;
                      const link = isAndroid
                        ? gameQuestionsQuery.content[currentQuestion]
                          .downloadLink.android
                        : gameQuestionsQuery.content[currentQuestion]
                          .downloadLink.ios;

                      const eventName = isAndroid
                        ? "EVENT_QUIZ_22_CLICK_APP_AND"
                        : "EVENT_QUIZ_22_CLICK_APP_IOS";

                      const handleClick = (e) => {
                        sendEvent(eventName);

                        setTimeout(() => {
                          window.open(link, "_blank", "noopener,noreferrer");
                        }, 150);
                        e.preventDefault();
                      };

                      return (
                        <a
                          href={link}
                          target="_blank"
                          rel="noopener noreferrer"
                          key={index}
                          onClick={handleClick}
                        >
                          <img
                            className="download"
                            src={item}
                            alt={
                              isAndroid ? "Android Download" : "iOS Download"
                            }
                          />
                        </a>
                      );
                    }
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              selected ===
                gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                    width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
              ) : (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                    width < 1020 ? "mobileImgHid" : "desktopImgHid"
                    ]
                  }
                  alt=""
                />
              )
            ) : (
              <div className="img-wrapper">
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                    width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
                {gameQuestionsQuery.content[currentQuestion]?.sideImageCopy && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]
                          ?.sideImageCopy),
                    }}
                  />
                )}
              </div>
            )}
            {XGA && (
              <StickyContent>
                <div className="desktop-buttons">
                  {ident === "vuse_fragrance_2025" &&
                    gameQuestionsQuery.content[currentQuestion].ident ===
                    "q9" && (
                      <Button
                        btnClass="outline yellow"
                        action={() =>
                          NiceModal.show("vuse-fragrance-2025-modal")
                        }
                      >
                        Inhaltsstoffe ansehen
                      </Button>
                    )}
                  {ident === "memory_5" &&
                    gameQuestionsQuery.content[currentQuestion].ident === "q7" && (
                      <Button
                        btnClass="outline yellow"
                        action={() => handleNextButtonClick("b")}
                      >
                        Nein – kein Rennen für mich
                      </Button>
                    )}
                  <Button action={() => handleNextButtonClick()}>
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        <div className="mobile-buttons">
          {ident === "vuse_fragrance_2025" &&
            gameQuestionsQuery.content[currentQuestion].ident === "q9" && (
              <StickyButton
                btnClass="outline yellow"
                action={() => NiceModal.show("vuse-fragrance-2025-modal")}
              >
                Inhaltsstoffe ansehen
              </StickyButton>
            )}
          {ident === "memory_5" &&
            gameQuestionsQuery.content[currentQuestion].ident === "q7" && (
              <StickyButton
                btnClass="outline yellow"
                action={() => handleNextButtonClick("b")}
              >
                Nein – kein Rennen für mich
              </StickyButton>
            )}
          <StickyButton action={() => handleNextButtonClick()}>
            {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
              "Nächste"}
          </StickyButton>
        </div>
      )}
    </section>
  );
}
